import classNames from 'classnames';
import { useOutlet } from 'react-router-dom';

type Props = {
  context?: unknown;
  height?: string;
};

export function Outlet({ context, height }: Props) {
  const outlet = useOutlet(context);

  if (!outlet) {
    return null;
  }

  return (
    <div
      data-outlet
      className={classNames([
        'fixed inset-0 z-50 h-screen w-full overflow-hidden bg-white lg:relative lg:bg-transparent',
        'lg:w-rsb xl:w-2rsb',
        height || `lg:h-screen-minus-nav`,
      ])}
    >
      {outlet}
    </div>
  );
}
